import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class BeachBall extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="66.88209" cy="123.57816" />
				<circle fill="#FFFFFF" cx="66.88209" cy="66.88209" r="66.86788" />
				<path fill="#75C69F" d="M7.32357,36.48303C-4.16592,58.99355-1.67568,84.9597,11.58183,104.4912
					c19.91488,6.07674,58.84557-7.29811,77.95752-21.1499l0,0C31.34703,53.63963,8.87794,35.497,8.15441,34.90799
					C7.87156,35.42799,7.59423,35.95274,7.32357,36.48303z" />
				<path fill="#FFEAAE" d="M75.76816,133.15813c20.99917-2.83449,40.30997-15.57458,50.67249-35.87709
					c0,0-9.02534,0.28831-36.90129-13.93974C89.59181,121.84248,76.14036,132.92883,75.76816,133.15813z" />
				<path fill="#F96E6E" d="M59.60795,0.40837L59.60795,0.40837c13.83794,6.10176,29.98386,38.69342,29.9314,82.93293
					c29.16844-17.74937,35.98014-45.63178,34.68265-50.86845c-0.00092-0.00163-0.00182-0.00326-0.00289-0.00497
					c-6.22633-10.39609-15.34878-19.22909-26.93797-25.14427C85.20886,1.16185,72.14295-0.97526,59.60795,0.40837z" />
				<circle fill="#987FEF" cx="89.59181" cy="83.23866" r="13.80837" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/BeachBall.js